<template>
    <!-- Main Start -->
    <main class="main">
      <!-- 404 Section Start -->
      <section class="page-not-found">
        <div class="container">
          <div class="row gx-md-2 gx-0 gy-md-0 gy-3">
            <div class="col-md-8 m-auto">
     
              <div class="page-image error-404">
                <h1 class="title-error">Error 404</h1>
                <h2 class="subtitle-error">Ups, página no encontrada.</h2>
                <br>
                <router-link :to="'/'" class="btn-solid mb-line">Volver al inicio </router-link>
              </div>

            </div>
          </div>
        </div>
      </section>
      <!-- 404 Section End -->
    </main>
    <!-- Main End -->
</template>
<script>
export default {
    name: 'PageNotFound',
}
</script>